
// import './App.css';
import { Route, Routes } from 'react-router-dom';
import RoomList from './Components/booking/RoomList';
import Homepage from './Components/HomePage/Homepage';
import HotelsList from './Components/HotelsList/HotelsList';
import BookingSummary from './Components/booking/BookingSummary';
import EventHall from './Components/hero/EventHall';
import OurSpecialPromo from './Components/hero/OurSpecialPromo';
import NavAbout from './Components/hero/NavAbout';
import Page404 from './Utilities/page404/Page404';
// import notFoundpage from './Utilities/404/notFoundpage';


function App() {
  return (
    <div className="App">
       

      <Routes>
          <Route path='/' element={<Homepage/>}/>
          <Route path='/availablehotels' element={<HotelsList/>}/> 
          <Route path='/hotel-rooms/:hotelId/:string' element={<RoomList/>}/>
          <Route path='/bookingSummary' element={<BookingSummary/>}/>
          <Route path='/EventHall' element={<EventHall/>}/>
          <Route path='/Special-Promo' element={<OurSpecialPromo/>}/>
          <Route path='/About-Residency-Hotels' element={<NavAbout/>}/>
         {/* <Route path='*' element={<notFoundpage />}/> */}
         <Route path='*' element={<Page404/>}/>
      </Routes>
    </div>
  );
}

export default App;
